import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodecovComponent } from './simple-icons-codecov.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodecovComponent ],
    exports:      [ SimpleIconsCodecovComponent ],
    bootstrap:    []
})
export class SimpleIconsCodecovModule {}
